import type { RouteRecordRaw } from 'vue-router';

/**
 * Rotas para o módulo de produto
 */
export const productsRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Products',
    path: '',
    component: () => import('@/views/private/products/ListProducts.vue'),
  },
  {
    name: 'CreateProducts',
    path: 'new',
    component: () => import('@/views/private/products/FormProductView.vue'),
  },
  {
    name: 'EditProduct',
    path: 'edit/:id',
    props: true,
    component: () => import('@/views/private/products/FormProductView.vue'),
  },
];
